import { IDotXetHocVuPhamViSinhVienActionTypes } from "../../action-types/xet-hoc-vu/IDotXetHocVuPhamViSinhVienActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetHocVuPhamViSinhVienReducer } from "../../reducer-model/xet-hoc-vu/IDotXetHocVuPhamViSinhVienReducer";

const iniState: IDotXetHocVuPhamViSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotXetHocVuPhamViSinhViens: [],
    hoc_ky: 0,
    nam_hoc: "",
    isHienThiTheoPhamViLop: false,
    isHienThiTheoTrangThai: false,
    focusedValueLop: {
        type: "he",
        id: 0,
        id_he: 0,
        khoa_hoc: 0,
        id_chuyen_nganh: 0,
        id_lops: [],
    },
}

export const dotXetHocVuPhamViSinhVienReducer = (state: IDotXetHocVuPhamViSinhVienReducer = iniState, action: IDotXetHocVuPhamViSinhVienActionTypes): IDotXetHocVuPhamViSinhVienReducer => {
    switch (action.type) {
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_LOAD_BY_HOC_KY_NAM_HOC_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_LOAD_BY_HOC_KY_NAM_HOC_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotXetHocVuPhamViSinhViens: action.payload,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_LOAD_BY_HOC_KY_NAM_HOC_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_INSERTS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_INSERTS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_INSERTS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_DELETES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_DELETES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_DELETES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_TREEVIEW_LOP_FOCUSED_VALUE_CHANGE":
            return {
                ...state,
                focusedValueLop: action.payload,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_CHANGE_IS_HIEN_THI_THEO_PHAM_VI_LOP":
            return {
                ...state,
                isHienThiTheoPhamViLop: action.payload,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN_CHANGE_IS_HIEN_THI_THEO_TRANG_THAI":
            return {
                ...state,
                isHienThiTheoTrangThai: action.payload,
            };
        default:
            return state;
    }
}
